"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeStore = exports.getStore = void 0;
var _redux = require("redux");
var _reduxSaga = _interopRequireDefault(require("redux-saga"));
var _connectedReactRouter = require("connected-react-router");
var _history = require("history");
var _rootReducer = require("./rootReducer");
var _rootSaga = require("./rootSaga");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var dev = process.env.NODE_ENV === 'development';
var devtools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
var composeEnhancers = dev && devtools ? devtools : _redux.compose;

/**
 * @deprecated
 */
var _store = null;

/**
 * @deprecated
 */
var getStore = exports.getStore = function getStore() {
  return _store;
};
var initializeStore = exports.initializeStore = function initializeStore() {
  var browserHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _history.createBrowserHistory)();
  // middlewares
  var sagaMiddleware = (0, _reduxSaga.default)();
  var routerMiddleware = (0, _connectedReactRouter.routerMiddleware)(browserHistory);
  var redusers = (0, _rootReducer.createReducers)(browserHistory);
  var store = (0, _redux.createStore)((0, _redux.combineReducers)(redusers), composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware, routerMiddleware)));
  _store = store;
  sagaMiddleware.run(_rootSaga.rootSaga);
  return {
    browserHistory: browserHistory,
    store: store
  };
};